export const TEST_ID = 'certificationsSection';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_LABEL = '';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const CERTIFICATION_CATEGORIES_COLUMN_KEY = 'certificationCategories';

export const CERTIFICATION_NUMBER_COLUMN_KEY = 'applicatorCertificationNumber';

export const EXPIRATION_DATE_COLUMN_KEY = 'certificationExpirationDate';

export const ISSUED_DATE_COLUMN_KEY = 'issuedDate';

export const STATE_COLUMN_KEY = 'stateOfCertification';

export const EMPTY_CELL_TEXT = '—';

export const DATE_LOCALE = 'en-US';

export const CERTIFICATION_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'UTC',
    year: 'numeric'
};
